import { render, staticRenderFns } from "./reserve_bill.vue?vue&type=template&id=35ac3574&scoped=true&"
import script from "./reserve_bill.vue?vue&type=script&lang=js&"
export * from "./reserve_bill.vue?vue&type=script&lang=js&"
import style0 from "./reserve_bill.vue?vue&type=style&index=0&id=35ac3574&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac3574",
  null
  
)

export default component.exports